<!-- 小票识别：上传图片或高拍仪拍照，识别车牌、箱号、铅封号、司机后回填任务下发弹窗 -->
<template>
    <div class="parse_ticket_wrap">
        <div class="parse_ticket">
            <span class="parse_ticket_label">识别小票</span>
            <el-upload ref="parseUpload" class="parse_ticket_item" action="#" :auto-upload="false"
                :show-file-list="false" accept=".jpg,.jpeg,.png,.bmp" :on-change="handleChange">
                <el-button plain type="primary" size="mini" icon="el-icon-picture-outline">选择图片</el-button>
            </el-upload>
            <el-button plain type="warning" size="mini" class="parse_ticket_item" icon="el-icon-camera"
                @click="openCamera">高拍仪拍照</el-button>
            <el-button plain type="success" size="mini" class="parse_ticket_item" icon="el-icon-view"
                :loading="parseLoading" @click="startParse">开始识别</el-button>
            <el-button plain type="info" size="mini" class="parse_ticket_item" v-if="currentFile" @click="clearFile">清空</el-button>
            <span class="parse_ticket_tip">图片一次只能识别一张，识别结果自动回填车牌、箱号、铅封号、司机</span>
            <!-- 预览：和证件照片一样，点开可以直接看大图 -->
            <div class="parse_ticket_preview" v-if="currentFile">
                <el-image class="parse_ticket_preview_img" :src="currentFile.url" fit="cover"
                    :preview-src-list="[currentFile.url]"></el-image>
            </div>
            <!-- 高拍仪拍照弹窗（只拍照不上传，图片交给本组件调识别接口） -->
            <photoScan ref="TicketDialog" onlyPhoto @uploadSuccess="handlePhoto"></photoScan>
        </div>
        <!-- 识别提醒：接口返回 warnings 才显示，空数组不占地方 -->
        <div class="parse_ticket_warn" v-if="warnings.length > 0">
            <p v-for="(item, index) in warnings" :key="index">{{ index + 1 }}. {{ item }}</p>
        </div>
    </div>
</template>

<script>
import photoScan from '@/components/wms/photoScan.vue';
export default {
    name: 'ParseTicket',
    components: {
        photoScan
    },
    data() {
        return {
            currentFile: null,   // 当前选中的图片 {name, raw, url}
            parseLoading: false, // 识别中
            warnings: [],        // 接口返回的识别提醒，空数组不显示
        }
    },
    beforeDestroy() {
        this.releasePreview();
    },
    methods: {
        // ==================== 上传 ====================
        // 选择图片：接口只收一张，选新的直接替换旧的
        handleChange(file) {
            const fileExt = file.name.replace(/.+\./, '').toLowerCase();
            // 小票只认图片，pdf、Excel 不走这个接口
            if (['jpg', 'jpeg', 'png', 'bmp'].indexOf(fileExt) === -1) {
                this.$message.error('只能上传 jpg/jpeg/png/bmp 格式的图片！');
                this.resetUpload();
                return;
            }
            // 大小校验 10M，和 AI识别 保持一致
            if (file.size / 1024 / 1024 >= 10) {
                this.$message.warning('图片大小不能超过10M！');
                this.resetUpload();
                return;
            }
            this.releasePreview();
            this.currentFile = {
                name: file.name,
                raw: file.raw,
                url: URL.createObjectURL(file.raw)
            };
            // 换了图片，上一张的识别提醒就作废
            this.warnings = [];
            // 清掉 el-upload 内部列表，不然同一个文件选第二次不触发
            this.resetUpload();
        },
        // 清空 el-upload 内部列表，不影响 currentFile
        resetUpload() {
            this.$nextTick(() => {
                if (this.$refs.parseUpload) {
                    this.$refs.parseUpload.clearFiles();
                }
            });
        },
        // 清空当前图片
        clearFile() {
            this.releasePreview();
            this.currentFile = null;
            // 图片清掉了，识别提醒也一起清掉
            this.warnings = [];
            this.resetUpload();
        },
        // 释放预览地址
        releasePreview() {
            if (this.currentFile && this.currentFile.url && this.currentFile.url.indexOf('blob:') === 0) {
                URL.revokeObjectURL(this.currentFile.url);
            }
        },
        // 父页面关闭“任务下发”弹窗时调用，清掉上一单拍的小票
        reset() {
            this.clearFile();
            this.parseLoading = false;
        },

        // ==================== 高拍仪 ====================
        // 打开高拍仪，写法和证件验证保持一致
        openCamera() {
            if (this.currentFile) {
                this.$message.warning('只能上传一张图片，请先清空！');
                return;
            }
            this.$refs.TicketDialog.dialogFormVisible = true;
            this.$nextTick(() => {
                this.$refs.TicketDialog.getCompetence();
            })
        },
        // 拍完照：只取第一张，一次识别一张
        handlePhoto(fileList) {
            if (!fileList || fileList.length === 0) {
                return;
            }
            if (fileList.length > 1) {
                this.$message.warning('一次只识别一张，已取第一张！');
            }
            this.releasePreview();
            this.currentFile = {
                name: fileList[0].name,
                raw: fileList[0].raw,
                url: fileList[0].url
            };
            // 换了图片，上一张的识别提醒就作废
            this.warnings = [];
            this.$message.success('拍照成功，请点开始识别');
        },

        // ==================== 识别 ====================
        // 开始识别：只有一张图片，字段名 file
        startParse() {
            if (!this.currentFile) {
                this.$message.warning('请先选择图片或拍照！');
                return;
            }
            if (this.parseLoading) {
                return;
            }
            const formData = new FormData();
            formData.append('file', this.currentFile.raw);
            // 重新识别前先清掉上一次的提醒，避免显示的还是旧内容
            this.warnings = [];
            this.parseLoading = true;
            this.$api.wmsAiParseCarBox(formData).then(res => {
                const data = res || {};
                // 识别提醒：接口没返回 warnings 就是空数组，空数组不显示
                this.warnings = this.normalizeWarnings(data.warnings);
                // 车牌兼容 carNo/plateNo 的返回写法，司机兼容 driverName
                const result = {
                    truckNo: data.truckNo || data.carNo || data.plateNo || '',
                    boxNo: data.boxNo || data.containerNo || '',
                    sealNo: data.sealNo || '',
                    driver: data.driver || data.driverName || ''
                };
                // 一个都没识别到，就别去覆盖用户手填的内容
                if (!result.truckNo && !result.boxNo && !result.sealNo && !result.driver) {
                    this.$message.warning('没有识别到车牌、箱号、铅封号或司机，请换一张清晰的小票再试！');
                    return;
                }
                this.$emit('success', result);
                this.$message.success('识别成功，已回填小票信息');
            }).catch(() => {
                // 接口报错 request.js 已经统一提示，这里只保证 loading 能关掉
            }).finally(() => {
                this.parseLoading = false;
            })
        },
        // 识别提醒统一成字符串数组：没返回、空数组都返回 []，页面就不显示
        normalizeWarnings(warnings) {
            if (!warnings) {
                return [];
            }
            if (!Array.isArray(warnings)) {
                return [warnings];
            }
            return warnings.filter(item => item);
        }
    }
}
</script>

<style lang="css" scoped>
.parse_ticket_wrap {
    margin-bottom: 10px;
}

.parse_ticket {
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    padding: 8px 10px;
    background-color: #f5f7fa;
    border: 1px dashed #dcdfe6;
    border-radius: 4px;
}

.parse_ticket_label {
    margin-right: 10px;
    font-size: 12px;
    font-weight: bold;
    color: #303133;
}

.parse_ticket_item {
    margin-right: 10px;
    margin-left: 0;
}

.parse_ticket_tip {
    color: #909399;
    font-size: 12px;
}

.parse_ticket_preview {
    margin-left: 10px;
}

.parse_ticket_preview_img {
    width: 60px;
    height: 45px;
    border: 1px solid #dcdfe6;
    border-radius: 4px;
    cursor: pointer;
}

/* 识别提醒：框下面的黄色小字，条数多时自己滚动，不把弹窗撑高 */
.parse_ticket_warn {
    margin-top: 4px;
    padding-left: 2px;
    max-height: 56px;
    overflow-y: auto;
}

.parse_ticket_warn p {
    margin: 0 0 2px;
    font-size: 12px;
    line-height: 18px;
    color: #e6a23c;
}
</style>
